import { TransactionsProvider } from './transactions.provider';
import { Transactions } from './transactions.view';

export function FeatureTransactions() {
   return (
      <TransactionsProvider>
         <Transactions />
      </TransactionsProvider>
   );
}
